// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
	production: false,
	//baseUrl: 'http://localhost:3000/api',
	baseUrl: 'https://ito-hub-page-dev.hosting.it-objects.de/api',
	localDb: false,
	useTranslationTool: false,
	msalConfig: {
		clientId: 'ed8f55e1-7338-450d-b186-91d406eaf8aa',
		authority: 'https://login.microsoftonline.com/1937b82c-3800-40de-82a9-8936537a0c62',
		tenantId: '1937b82c-3800-40de-82a9-8936537a0c62',
		redirectUri: 'https://ito-hub-page-dev.hosting.it-objects.de/',
		accessAPI: 'api://b229c37a-da68-40f1-9e49-5db37be8f6af/access-api',
		baseUrl: 'https://login.microsoftonline.com',
		emailSuffix: 'it-objects',
		profileUrl: 'https://myaccount.microsoft.com/?ref=MeControl',
	},
};
